import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';

import HistoryContainer from 'containers/HistoryContainer';
import Paper from 'components/Paper';

import EditableV2 from 'routes/Documents/containers/EditableV2';
import CommonHeader from 'routes/Documents/components/CommonHeader';
import BottomFormControls from 'routes/Documents/components/BottomFormControls';
import { getLatestUnfinishedCommit } from 'lib/documentHandling';

import Form from './Form';
import historyMapper, { sorter } from './historyMapper';

const Rehabilitation = ({ names, documents, editingDocument, onStartEdit, onCreate }) => (
  <div>
    <Paper topMargin={false}>
      <Grid fluid>
        <CommonHeader
          names={names}
          localeId="rehabilitation.title"
          infoText="rehabilitation.infoText"
          addNewText="rehabilitation.addNew"
          mode="create"
          editing={editingDocument}
          startEdit={onCreate}
        />
      </Grid>
      {editingDocument && (
        <EditableV2
          documentId={editingDocument.documentId}
          moduleName={names[0]}
          editedCommit={getLatestUnfinishedCommit(editingDocument)}
        >
          <Form />
        </EditableV2>
      )}
      {!editingDocument && (
        <HistoryContainer
          documents={documents}
          emptyText="rehabilitation.emptyText"
          sorter={sorter}
          mapper={historyMapper(names[0], onStartEdit)}
        />
      )}
    </Paper>
    {editingDocument && (
      <BottomFormControls
        name={names[0]}
        editId={editingDocument.documentId}
        commitId={getLatestUnfinishedCommit(editingDocument).commitId}
      />
    )}
  </div>
);

Rehabilitation.propTypes = {
  names: PropTypes.array,
  documents: PropTypes.array,
  onStartEdit: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  editingDocument: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export default Rehabilitation;
